import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { LogoComponent } from "./components/logo";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <LogoComponent mdxType="LogoComponent"></LogoComponent>
    <p>{`A backend framework for solid web apps based on node.js`}</p>
    <h1 {...{
      "id": "github"
    }}>{`GitHub`}</h1>
    <p>{`We are happy to support us on github from `}<a parentName="p" {...{
        "href": "https://github.com/tareksalem/grandjs"
      }}>{`here`}</a></p>
    <p>{`Also we will be happy if you want to contribute us or have an issue you can open a ticket on github`}</p>
    <h1 {...{
      "id": "whats-new-"
    }}>{`Whats New ?`}</h1>
    <p>{`Grandjs now supports the following`}</p>
    <ul>
      <li parentName="ul">{`JSX Syntax for rendering dynamic content instead of using template engins`}</li>
      <li parentName="ul">{`many of express packages are now compatible with Grandjs such as cookie-parser, session, flash, morgan, express-fileupload, body-parser`}</li>
      <li parentName="ul">{`Typescript support!, Grandjs has major updates one of these updates is rebuilding the package again using typescript and changing the architecture of the project`}</li>
    </ul>
    <h1 {...{
      "id": "introduction"
    }}>{`Introduction`}</h1>
    <p>{`You want to build a solid web application but you don't want to use express and a lot of packages you need to build a basic website, Grandjs is one framework includes all main functionalities you need to build amazing, solid and secured web application without need for a ton of packages and libraries.`}</p>
    <ul>
      <li parentName="ul">{`Grandjs is built for solid and extended web apps`}</li>
    </ul>
    <p><img alt="GitHub contributors" src="https://img.shields.io/github/contributors/tareksalem/grandjs.svg?style=flat-square" />{`
`}<img alt="npm" src="https://img.shields.io/npm/v/grandjs.svg" />{`
`}<img alt="GitHub code size in bytes" src="https://img.shields.io/github/languages/code-size/tareksalem/grandjs.svg" />{`
`}<img alt="npm" src="https://img.shields.io/npm/dt/grandjs.svg?color=green&style=popout" /></p>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <p>{`1- you need to install node.js on your system
2- init a new project using npm, so then we will be able to install this framework`}</p>
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <ul>
      <li parentName="ul">{`fewer packages and more productivity`}</li>
      <li parentName="ul">{`Framework includes the most needed functionalities to build a perfect web app`}</li>
      <li parentName="ul">{`depends on Handlebars template Engine which is friendly with many developers`}</li>
      <li parentName="ul">{`solid routing system built on Javascript object-oriented programming and you can extend it as you need`}</li>
      <li parentName="ul">{`controlled handling for every error page in your app`}</li>
      <li parentName="ul">{`Grandjs is built for solid and extended web apps`}</li>
      <li parentName="ul">{`Built in template engine using jsx`}</li>
      <li parentName="ul">{`Extendable Routing System`}</li>
      <li parentName="ul">{`Accepts Express Packages such as (body-parser, cookie-parser, morgan, cors)`}</li>
      <li parentName="ul">{`built in cors Handler
Built in request body parser
Usable for Typescript Apps`}</li>
    </ul>
    <h2 {...{
      "id": "objectives"
    }}>{`Objectives`}</h2>
    <p>{`We aim to make grandjs the successor of express js with new vision, architecture, and modern javascript features like Router inheritance to build extendable, scalable web applications without repeating your self!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      